namespace Portico.Services.Mappers {
    import ent = Portico.Models.Enterprise;
	import leg = Portico.Models.Legacy;
	import psgm = apigateway.models;

	export class SurveyMapper {

		toLegacySurveyQuestion(surveyId: number, questionId: number, answer: ent.SurveySessionAnswer): leg.SurveyQuestionModel {
			let obj = new leg.SurveyQuestionModel();
			obj.surveyId = surveyId;
			obj.questionId = questionId;
			obj.answerKey = answer.answerId;
			obj.answerText = answer.answerValue;
			return obj;
		}

		toLegacyDemographics(account: ent.Account, memberNumber: string): leg.EnrollmentDemographicsModel {
			let e: ent.Patient = account.patient;
			let obj = new leg.EnrollmentDemographicsModel();

			// postpend middle name
			obj.firstName = `${_.isNil(e.firstName) ? '' : e.firstName}${_.isNil(e.middleName) ? '' : ' ' + e.middleName}`;
			// postpend suffix			
			obj.lastName = `${_.isNil(e.lastName) ? '' : e.lastName}${_.isNil(e.suffix) ? '' : ' ' + e.suffix}`;
			obj.dateOfBirth = _.isNil(e.dateOfBirth) ? '' : moment(e.dateOfBirth instanceof Date ? e.dateOfBirth : new Date(e.dateOfBirth)).format('L');
			obj.gender = _.isNil(e.gender) ? '' : e.gender;
			obj.address1 = _.get(e, 'addresses[0].address1', '');
			obj.address2 = _.get(e, 'addresses[0].address2', '');
			obj.city = _.get(e, 'addresses[0].city', '');
			obj.state = _.get(e, 'addresses[0].state', '');
			obj.postalCode = _.get(e, 'addresses[0].zip', '');
			obj.email = _.get(e, 'emailAddresses[0].address', '');
			obj.homePhone = _.get(e, 'phoneNumbers[0].number', '');
			obj.memberNumber = _.isNil(memberNumber) ? '' : memberNumber;
			// default extra properties
			obj.personId = null;
			obj.mobilePhone = ''; // Not used by service
			obj.country = '';
			obj.communicationTypes = null;
			return obj;
		}

		toCouponDemographics(account: ent.Account, memberNumber: string): psgm.EnrollmentDemographicsModel {
			let e: ent.Patient = account.patient;
			let obj =  {} as psgm.EnrollmentDemographicsModel;

			// postpend middle name
			obj.firstName = `${_.isNil(e.firstName) ? '' : e.firstName}${_.isNil(e.middleName) ? '' : ' ' + e.middleName}`;
			// postpend suffix			
			obj.lastName = `${_.isNil(e.lastName) ? '' : e.lastName}${_.isNil(e.suffix) ? '' : ' ' + e.suffix}`;
			obj.dateOfBirth = _.isNil(e.dateOfBirth) ? '' : moment(e.dateOfBirth instanceof Date ? e.dateOfBirth : new Date(e.dateOfBirth)).format('L');
			obj.gender = _.isNil(e.gender) ? '' : e.gender;
			obj.address1 = _.get(e, 'addresses[0].address1', '');
			obj.address2 = _.get(e, 'addresses[0].address2', '');
			obj.city = _.get(e, 'addresses[0].city', '');
			obj.state = _.get(e, 'addresses[0].state', '');
			obj.postalCode = _.get(e, 'addresses[0].zip', '');
			obj.email = _.get(e, 'emailAddresses[0].address', '');
			obj.homePhone = _.get(e, 'phoneNumbers[0].number', '');
			obj.memberNumber = _.isNil(memberNumber) ? '' : memberNumber;
			// default extra properties
			obj.personId = null;
			obj.mobilePhone = ''; // Not used by service
			obj.country = '';
			obj.communicationTypes = null;
			return obj;
		}


		// toLegacy: transform enterprise survey to legacy survey
		toLegacy(surveySession: ent.SurveySession): leg.SurveyQuestionModel[] {
			const legacySurvey: leg.SurveyQuestionModel[] = [];

            if (surveySession && surveySession.surveySessionAnswers) {
                surveySession.surveySessionAnswers.forEach((q) => {
				    legacySurvey.push(new leg.SurveyQuestionModel({
					    surveyId: surveySession.surveyId,
					    questionId: q.questionId,
					    answerKey: q.answerId,
					    answerText: q.answerValue
				    }));
			    });
            }

			return legacySurvey;
		}
	}
}